import React from 'react'
import PropTypes from 'prop-types'

import {
  Delay,
  RealtimeWrapper,
  StatusLabel,
  TheoreticalAndDelayWrapper,
  TheoreticalTime,
  TimeSpan,
} from '../containers/Passages.styles'
import {
  calculateDeviationInMinutes,
  getDelayColor,
  isArrivingAtStop,
} from '../containers/PassagesUtils'
import RealtimePulse from './RealtimePulse'
import StatusToggler from './StatusToggler'
import { getStatusText } from '../helpers/irtis.helpers'

const RealtimeIrtis = ({
  line,
  departureTimeColor,
  lightMode,
  currentTime,
  time,
  theoreticalTime,
  realtime,
  isPreSubway,
}) => {
  const isAtStop = line.predictionStatussen.includes('ATSTOP')
  const isDeparted = line.predictionStatussen.includes('DEPARTED')

  const isArriving = isArrivingAtStop(line.vertrekRealtimeTijdstip, currentTime)

  const delay = calculateDeviationInMinutes(
    line.vertrekTheoretischeTijdstip ||
      line.aankomstTheoretischTijdstip ||
      line.aankomstTheoretischeTijdstip,
    line.vertrekRealtimeTijdstip || line.aankomstRealtimeTijdstip,
  )
  return (
    <div data-testid="irtis-realtime">
      <RealtimeWrapper isPreSubway={isPreSubway}>
        <StatusToggler>
          {(isAtStop || isArriving || isDeparted) && (
            <StatusLabel lightMode={lightMode} isPreSubway={isPreSubway}>
              {getStatusText(isAtStop, isArriving, isDeparted)}
            </StatusLabel>
          )}
          {line.eindHalte && (
            <StatusLabel
              lightMode={lightMode}
              isPreSubway={isPreSubway}
              data-testid="status-label-eindhalte"
            >
              Eindhalte
            </StatusLabel>
          )}
        </StatusToggler>
        <TimeSpan color={departureTimeColor} isPreSubway={isPreSubway}>
          {time === 0 ? 'Nu' : time}
          {time > 0 && <span className="minute"> min</span>}
        </TimeSpan>
        {realtime && <RealtimePulse variant={lightMode ? '' : 'dark'} />}
      </RealtimeWrapper>

      <TheoreticalAndDelayWrapper>
        <TheoreticalTime color={departureTimeColor} isPreSubway={isPreSubway}>
          {theoreticalTime}
        </TheoreticalTime>
        <Delay
          color={getDelayColor(delay, lightMode)}
          isPreSubway={isPreSubway}
        >
          {delay && (
            <>
              {delay >= 0 ? '+ ' : '- '} {Math.abs(delay)}
            </>
          )}
        </Delay>
      </TheoreticalAndDelayWrapper>
    </div>
  )
}

RealtimeIrtis.propTypes = {
  line: PropTypes.shape({
    eindHalte: PropTypes.bool,
    predictionStatussen: PropTypes.array,
    vertrekTheoretischeTijdstip: PropTypes.number,
    vertrekRealtimeTijdstip: PropTypes.number,
    aankomstTheoretischTijdstip: PropTypes.number,
    aankomstTheoretischeTijdstip: PropTypes.number,
    aankomstRealtimeTijdstip: PropTypes.number,
  }).isRequired,
  error: PropTypes.bool.isRequired,
  currentTime: PropTypes.number.isRequired,
  lightMode: PropTypes.bool.isRequired,
  departureTimeColor: PropTypes.string.isRequired,
  showEindHaltes: PropTypes.bool.isRequired,
  theoreticalTime: PropTypes.string.isRequired,
  time: PropTypes.any.isRequired,
  realtime: PropTypes.bool.isRequired,
  isPreSubway: PropTypes.bool.isRequired,
}

export default RealtimeIrtis
